import checkboxChecked from './checkbox_checked.svg';
import checkboxCheckedDisabled from './checkbox_checked_disabled.svg';
import checkboxUnchecked from './checkbox_unchecked.svg';
import checkboxUncheckedDisabled from './checkbox_unchecked_disabled.svg';
import radioChecked from './radio_checked.svg';
import radioCheckedDisabled from './radio_checked_disabled.svg';
import radioUnchecked from './radio_unchecked.svg';
import radioUncheckedDisabled from './radio_unchecked_disabled.svg';

import modalError from './modalError.svg';
import modalWarning from './modalWarning.svg';
import modalSuccess from './modalSuccess.svg';

export const checkboxCheckedIcon = checkboxChecked;
export const checkboxCheckedDisabledIcon = checkboxCheckedDisabled;
export const checkboxUncheckedIcon = checkboxUnchecked;
export const checkboxUncheckedDisabledIcon = checkboxUncheckedDisabled;
export const radioCheckedIcon = radioChecked;
export const radioCheckedDisabledIcon = radioCheckedDisabled;
export const radioUncheckedIcon = radioUnchecked;
export const radioUncheckedDisabledIcon = radioUncheckedDisabled;

export const modalErrorImage = modalError;
export const modalWarningImage = modalWarning;
export const modalSuccessImage = modalSuccess;
